import { render, staticRenderFns } from "./finaly.vue?vue&type=template&id=cd8f423c&scoped=true&"
import script from "./finaly.vue?vue&type=script&lang=js&"
export * from "./finaly.vue?vue&type=script&lang=js&"
import style0 from "./finaly.vue?vue&type=style&index=0&id=cd8f423c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f423c",
  null
  
)

export default component.exports